angular.module('impactx.productcoding').controller('ProductCodingMultiSelectedDialogCtrl', ['TranslationService',
    '$mdDialog',
    'themeFactory',
    ProductCodingMultiSelectedDialogCtrl]);

function ProductCodingMultiSelectedDialogCtrl(TranslationService, $mdDialog, themeFactory)
{
    this.theme = themeFactory.getTheme();
    this.okLAbel = TranslationService.get("ok");
    this.errorLabel = TranslationService.get("error");

    this.confirm = function (){
        $mdDialog.hide();
    }

    this.getIconClass = function (entry) {
        var result = '';

        switch (entry.type) {
            case "PRG":
                result += (entry.coding ? 'mdi-folder-refresh' : 'mdi-folder') + ' mdi-icon-yellow';
                break;
            case "PRO":
                result += (entry.coding ? 'mdi-cog-refresh' : 'mdi-cog') + ' mdi-icon-dark-grey';
                break;
            default:
                return "";
        }

        return result;
    }
}